import { render, staticRenderFns } from "./MultiLangInput.vue?vue&type=template&id=90d9a9f2&scoped=true"
import script from "./MultiLangInput.vue?vue&type=script&lang=js"
export * from "./MultiLangInput.vue?vue&type=script&lang=js"
import style0 from "./MultiLangInput.vue?vue&type=style&index=0&id=90d9a9f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d9a9f2",
  null
  
)

export default component.exports